import { entityRegistry } from '@app/icare/entities/registry'
import { createQueryStore, QueryBaseSchema } from '@pkg/api/query'
import { EntityIndexPage } from '@pkg/ui/layout/EntityIndexPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/medizintechnik/')({
  component: RouteComponent,
})

const queryStore = createQueryStore({
  schema: entityRegistry.medicalTechnology.search.filterSchema ?? QueryBaseSchema,
})

function RouteComponent() {
  return <EntityIndexPage entityName="medicalTechnology" queryStore={queryStore} />
}
